import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import CommercialPackageLabel from './CommercialPackageLabel';

const { Link } = deriveLinkComponents(
  CommercialPackageLabel,
  api.getCommercialPackage,
);

// eslint-disable-next-line import/prefer-default-export
export { Link as CommercialPackageLabel };
